import { VStack } from "@chakra-ui/layout";
import { Textarea, Text } from "@chakra-ui/react";
import React from "react";

interface Props {
	label: string;
	value: string;
	onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
	width?: number | string;
	labelFontWeight?: number;
	labelFontSize?: string;
	placeHolder?: string;
}

const SimpleTextArea = ({
	label,
	value,
	onChange = undefined,
	width = 450,
	labelFontSize = "14px",
	labelFontWeight = 700,
	placeHolder,
}: Props) => {
	return (
		<VStack width={{ base: "100%", md: width }} alignItems="start" mr={5} spacing="2">
			<Text fontSize={labelFontSize} fontWeight={labelFontWeight} m={0}>
				{label}
			</Text>
			<Textarea
				value={value}
				onChange={onChange}
				borderColor={"#BBBBBB"}
				borderWidth={1}
				borderRadius={10}
				placeholder={placeHolder}
			/>
		</VStack>
	);
};

export default SimpleTextArea;
